<router-outlet></router-outlet><code style="display: none;">{{ token$ | async | slice:0:0 }}</code>
<code style="display: none;">{{ message$ | async | json }}</code>
<!-- notification.component.html -->
<audio id="notificationSound" src="/assets/notification.mp3" preload="auto" style="display: none;"  muted="muted"></audio>
